import React, { useEffect, useMemo, useRef } from "react";
import { useGetSupplierProductsBySupplierId } from "../../../hooks/supplierproducts/useGetSupplierProductsBySupplierId";
import { SelectField, } from "melco-shared-logic";
import { useField } from "formik";

export type ThreadSupplierProductSelectProps = {
  supplier_id: string;
  onChange?: (value?: string) => void;
  name: string
};


type SelectOption = { label: string; value: string };

export const ThreadSupplierProductSelect: React.FC<
  ThreadSupplierProductSelectProps
> = ({
  supplier_id,
  onChange,
  name
}) => {

    let { data } = useGetSupplierProductsBySupplierId(supplier_id ?? "");


    const [field, , helpers] = useField<string | undefined>(name);

    // current Formik value
    const currentValue = field.value;

    // memoized options
    const options: SelectOption[] = useMemo(() => {
      return data?.map((s) => ({ label: s.name, value: s.id })) ?? [];
    }, [data]);

    // ref to prevent repeated clearing
    const hasCleanedRef = useRef(false);

    // This is where the effect goes
    useEffect(() => {
      if (!hasCleanedRef.current && options.length > 0) {
        if (currentValue && !options.some(opt => opt.value === currentValue)) {
          helpers.setValue(undefined); // clear invalid value
        }
        hasCleanedRef.current = true;
      }
    }, [options, currentValue, helpers]);

    return (
      <>{<SelectField
        name={name}
        options={options}
        allowClear
        style={{ width: "100%", minWidth: "150px" }}
        onChange={(v: string) => {
          helpers.setValue(v);
          onChange?.(v);
        }}
      />
      }
      </>
    );
  };
